module.exports = __webpack_public_path__ + "static/media/Subtract 2.33d6c271.png";